import debounce from "lodash.debounce";
import { useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Stack from "@mui/material/Stack";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import Title from "../../../common/Title";
import { copyData } from "../../../../utils/copy";
import useAxios from "../../../../hooks/useAxios";
import { CLIENTS } from "../../../../constants/value";
import TmobilejFilterGroupAssignList from "./FilterGroupAssignList";
import { __getTmobilejFilterGroupAssignList } from "../../../../api/sim";

const TmobilejFilterGroupAssignBatch = () => {
  const { batch_id } = useParams();
  const [data, setData] = useState([]);
  const [metaData, setMetaData] = useState({
    page: 1,
    page_size: 20000,
    total: 1,
  });
  const [response, call, loading] = useAxios({
    ...__getTmobilejFilterGroupAssignList,
  });

  const COPY_KEYS = [
    "id",
    "msisdn",
    "subscriber_id",
    "filter_type",
    "selected_group_names",
    "selected_group_ids",
    "status",
    "batch_id",
    "created_at",
    "last_updated",
  ];

  const debouncedFetchData = debounce((query) => {
    call(query);
  }, 500);

  useEffect(() => {
    debouncedFetchData({
      params: {
        client: CLIENTS.tmobilej,
        page_size: 20000,
        batch_id,
      },
    });
    return () => debouncedFetchData.cancel();
  }, []);

  useEffect(() => {
    if (!response?.status) return;
    setMetaData({
      page: response.data.page,
      page_size: response.data.page_size,
      total: response.data.total,
    });
    setData(response.data.data || []);
  }, [response]);

  return (
    <Box sx={{ width: "100%" }}>
      <Title
        variant="h5"
        content={`Bulk Assign Filter Groups Batch ID: ${batch_id}`}
        gutterBottom
      />
      <Grid container justifyContent="flex-start" spacing={2}>
        <Grid item sx={{ mb: "10px" }}>
          <Stack spacing={2} direction="row">
            <Button
              variant="contained"
              color="secondary"
              disabled={loading}
              onClick={() => copyData(data, COPY_KEYS)}
            >
              <ContentCopyIcon sx={{ mr: "5px" }} /> Copy Data
            </Button>
          </Stack>
        </Grid>
      </Grid>

      <TmobilejFilterGroupAssignList
        data={data}
        loading={loading}
        meta={{ ...metaData, page_size: 100 }}
        client={true}
        handleColumnClick={(key) => copyData(data, [key])}
      />
    </Box>
  );
};

export default TmobilejFilterGroupAssignBatch;
